module.exports = __webpack_public_path__ + "img/pointer02.dfaa77a3.png";